module.exports = __webpack_public_path__ + "img/PR5939.f01d9b30.png";